<!--
Paginated Autocomplete Component
A customized Material autocomplete dropdown with pagination support.
Features:
- Custom or default item templates
- Optional checkbox selection
- Pagination controls with previous/next buttons
- Prevents dropdown from closing on certain interactions
-->
<mat-autocomplete [panelWidth]="panelWidth"
  #auto="matAutocomplete"
  [displayWith]="displayFn"
  (optionSelected)="onSelectionChange($event)"
  class="custom-autocomplete"
  >
  @for (item of searchItems$ | async; track item) {
    <mat-option [value]="item" (mousedown)="preventClose($event)">
      @if (customTemplate) {
        <ng-container *ngTemplateOutlet="customTemplate; context: {$implicit: item, showCheckboxes: showCheckboxes, isSelected: isItemSelected(item)}"></ng-container>
      } @else {
        <div class="search-item">
          @if (showCheckboxes) {
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="onCheckboxChange($event, item)"
              [checked]="isItemSelected(item)">
            </mat-checkbox>
          }
          <div [class.search-item-content]="showCheckboxes">
            <div class="search-item-title">
              <ip-icon [ipType]="item.ipType"></ip-icon>
              <span class="identifier">{{ item.identifier }}</span>
              @if (item.serial && item.serial.trim() !== '') {
                | <small>SN: {{ item.serial }}</small>
              }
            </div>
            <div class="search-item-subtitle">Title: {{ item.title }}</div>
          </div>
        </div>
      }
    </mat-option>
  }
  @if (paginationInfo.value.currentPage !== paginationInfo.value.totalPages) {
    <div>
      @if (!isAll) {
        <div class="bottom-section">
          <button mat-icon-button (click)="previousPage($event)" (mousedown)="preventClose($event)" [disabled]="paginationInfo.value.currentPage <= 1">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span>Page {{ paginationInfo.value.currentPage }} of {{ paginationInfo.value.totalPages }}</span>
          <button mat-icon-button (click)="nextPage($event)" (mousedown)="preventClose($event)" [disabled]="paginationInfo.value.currentPage >= paginationInfo.value.totalPages">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }
      @if (isAll) {
        <div class="bottom-section">
          <span class="overflow-message">Displaying {{ paginationInfo.value.resultLength }} results out of {{ paginationInfo.value.totalRows }} total. Narrow search input to see additional results.</span>
        </div>
      }
    </div>
  }
</mat-autocomplete>
